import { Reducer } from "react";
import { Action } from "redux";
import Actions from "../actions";
import { AlertsState } from "./state";
import { AlertAction, AlertDismissAction } from "./types";

const initialState: AlertsState = {
    items: [],
}

export const reconsilor = (_: AlertsState): AlertsState => initialState;

export const reducer: Reducer<AlertsState | undefined, Action<Actions>> = (state = initialState, action): AlertsState => {
    switch (action.type) {
        case Actions.LoggedOut: 
            return initialState;
        case Actions.Alert:
            return handleAlert(state, action as AlertAction);
        case Actions.AlertDismiss:
            return handleAlertDismiss(state, action as AlertDismissAction);
        default:
            return state;
    }
};

const handleAlert = (state: AlertsState, action: AlertAction): AlertsState => ({
    ...state,
    items: state.items.concat(action.payload),
});

const handleAlertDismiss = (state: AlertsState, action: AlertDismissAction): AlertsState => ({
    ...state,
    items: state.items.filter(alert => alert.id !== action.payload),
});